import Controller from '@ember/controller';
import { service } from '@ember/service';

export default class AdminProfileController extends Controller {
  // Services
  @service flashMessages;
  @service headData;
  @service intl;
  @service recordLocks;
  @service recordStatus;

  // Getter and setter
  get isModelDisabledOrInvalid() {
    return this.recordStatus.isDisabledOrInvalid(this.model);
  }

  // Actions
  saveUser = async (user) => {
    await this.saveRecord(user);

    this.flashMessages.success('profile.userSaved');
  };

  saveSftpUser = async (sftUser) => {
    await this.saveRecord(sftUser);

    this.flashMessages.success('profile.sftpUserSaved');
  };

  setHeadData = () => {
    this.headData.title = this.intl.t('profile.title');
    this.headData.favicon = 'user';
  };

  generateNewPassword = async (sftpUser) => {
    sftpUser.set('password', null);

    await this.saveRecord(sftpUser);

    this.flashMessages.success('profile.passwordGenerated');
  };

  // Functions
  async saveRecord(model) {
    try {
      await this.recordLocks.lockStatus(model);

      if (!this.recordLocks.isLocked(model)) {
        await model.save();

        // TODO: Lock after save
        await this.recordLocks.lock(model);

        return model;
      }
    } catch (error) {
      this.flashMessages.serverError(error);
    }
  }
}
